module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AceCyYkK/7FigAAAOVJREFUKM+tkjFOAlEQhr9dWi9ggjFBLmBDovEImAl5HQWcwMJ76CGUbDmJP1ego+EGFJsQDmCpcWnAvKwv4AJ/M8m8mS8z/xvYI8l38Uny5zjXWBGsJ/mX5N+S3x+CZgegl8CqVndtFspGQMkz4AJYADe15yVwC3yaharem6eA28JJAgbQAYoU7A8w8u0NsD1u9CUvUn7mMcwsIPkQGP3j34aSj7c9aQ8lfwSmDQ9iYBY+fieM1uwABVA1gFXAu+Td3ZZZNF0JXB13tayBtln4ySRvATPgjtM0Bx5y4OUMMIAe8LoBNXpbZ6ivTmwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/drop-up-icon.png
// module id = 2375
// module chunks = 7